import { formatDateFr } from './consignes';
import logoTanoEd from '../../assets/logoTanoEd.png';

/**
 * En-tête compact répété sur CHAQUE page imprimée.
 *
 * Layout sur une seule ligne fine (~32px) :
 *   [logo] TANOED · Exercice d'entraînement                  24 Avril 2026
 *   ──────────────────────────────────────────────────────────────────────
 *
 * Remplace l'ancien `Masthead` massif (~150px) qui n'était présent que sur
 * la page 1. L'idée : densifier l'info de tête pour libérer de la place,
 * tout en gardant la marque visible sur toutes les pages imprimées.
 */
const CompactHeader = ({ titre, date, documentType = 'evaluation', pageNum, pageTotal }) => {
    const isEntrainement = documentType === 'entrainement';
    const defaultTitle = isEntrainement ? 'Exercice d\'entraînement' : 'Évaluation';
    const dateFr = formatDateFr(date);
    // « page X/Y » sur la même ligne que la date : aucune hauteur ajoutée,
    // donc aucune incidence sur les budgets mesurés par la sonde de chrome.
    const pagination = pageNum && pageTotal > 1 ? `page ${pageNum}/${pageTotal}` : '';
    const droite = [dateFr, pagination].filter(Boolean).join(' · ');
    return (
        <header className="ep-running-header">
            <div className="ep-running-left">
                <img src={logoTanoEd} alt="TanoEd" className="ep-running-logo" />
                <span className="ep-running-brand">TANOED</span>
                <span className="ep-running-sep">·</span>
                <span className="ep-running-title">{titre || defaultTitle}</span>
            </div>
            {droite && <span className="ep-running-date">{droite}</span>}
        </header>
    );
};

export default CompactHeader;
